import { InforModal } from '../model/datatype';
import Modal from 'react-bootstrap/Modal';
import { Container, Row, Col, Button } from 'react-bootstrap';

export const InfoChartModal = (props: any) => {
  // console.log('props=', props);
  let chart: any;
  if (props.itemTypeTable === 'Driver Shirt') {
    chart = '../images/uniform_size/Driver Shirt.png';
  }

  if (props.itemTypeTable === 'Maintenance') {
    chart = '../images/uniform_size/MT Shirt size.png';
  }

  if (props.itemTypeTable === 'Driver pants') {
    chart = '../images/uniform_size/Driver Pants.png';
  }

  if (props.itemTypeTable === 'Maintenance pants') {
    chart = '../images/uniform_size/MT Pants size.png';
  }

  if (
    props.shirtGender === 'Male' &&
    props.itemtype === 'shirt' &&
    props.itemTypeTable !== 'Driver Shirt' &&
    props.itemTypeTable !== 'Maintenance'
  ) {
    chart = '../images/uniform_size/Male shirt.png';
  }
  if (
    props.shirtGender === 'Female' &&
    props.itemtype === 'shirt' &&
    props.itemTypeTable !== 'Driver Shirt' &&
    props.itemTypeTable !== 'Maintenance'
  ) {
    chart = '../images/uniform_size/Female shirt.png';
  }

  if (
    props.pantGender === 'Male' &&
    props.itemtype === 'pants' &&
    props.itemTypeTable !== 'Driver pants' &&
    props.itemTypeTable !== 'Maintenance pants'
  ) {
    chart = '../images/uniform_size/Male Pants.png';
  }
  if (
    props.pantGender === 'Female' &&
    props.itemtype === 'pants' &&
    props.itemTypeTable !== 'Driver pants' &&
    props.itemTypeTable !== 'Maintenance pants'
  ) {
    chart = '../images/uniform_size/Female Pants.png';
  }

  if (props.itemtype === 'dress') {
    chart = '../images/uniform_size/Dress size.png';
  }

  if (props.itemtype === 'slippers') {
    chart = '../images/uniform_size/Slippers size.png';
  }

  if (props.itemtype === 'bras') {
    chart = '../images/uniform_size/Bra size.png';
  }

  // if (props.itemtype === 'mtshirt') {
  //   chart = '../images/uniform_size/MT Shirt size.png';
  // }

  // if (props.itemtype === 'mtpant') {
  //   chart = '../images/uniform_size/MT Pants size.png';
  // }
  // console.log('shirtgendor=>', props.shirtGender);
  // console.log('pantsgendor=>', props.pantGender);
  // console.log('itemType=>', props.itemtype);
  // console.log('itemTypeTable=>', props.itemTypeTable);
  return (
    <Modal
      show={props.showModal}
      onHide={props.handleContinue}
      className="custom-modal-chart"
    >
      <Modal.Header closeButton>
        {/* <Modal.Title className="text-center w-100">Your Uniform</Modal.Title> */}
      </Modal.Header>
      <Modal.Body className="m-0 p-0">
        <div className="uniform-survey-info mb-2">
          <Container>
            <Row>
              <Col xs={12} md={12} lg={12} className="m-0 p-1">
                <a href={chart} target="blank">
                  <img
                    src={chart}
                    alt="UniformSurvey"
                    width={100 + '%'}
                    className="mt-2 rounded"
                  />
                </a>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};
